import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './PortalNavbar.css';

/**
 * Navbar condivisa del portale.
 * Mostra il logo "AISA TALENTGPT" (link alla home/hub) ed eventualmente
 * il nome della sezione corrente come breadcrumb.
 *
 * Props:
 *  - section: stringa con il nome della sezione (es. "Chat", "Gestione Candidati").
 *             Se assente, viene mostrato solo il logo (caso hub).
 *  - showLogout: se true mostra il bottone di logout a destra (default false).
 */
function PortalNavbar({ section, showLogout = false }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <nav className="ds-navbar">
      <Link to="/" className="ds-navbar-logo">AISA TALENTGPT</Link>
      {section && (
        <>
          <span className="ds-navbar-sep">›</span>
          <span className="ds-navbar-page">{section}</span>
        </>
      )}
      <div className="ds-navbar-right">
        {user?.username && (
          <span className="portal-navbar-user">{user.username}</span>
        )}
        {showLogout && (
          <button className="ds-btn ds-btn-ghost" onClick={handleLogout}>
            Logout
          </button>
        )}
      </div>
    </nav>
  );
}

export default PortalNavbar;
